import type React from 'react'

import type {
  SectionChangeHandler,
  SectionStats,
  SectionType,
} from '../../../../types'
import { BreakdownItem } from './components'

interface Props {
  stats: SectionStats
  activeSection: SectionType
  changes: boolean
  comparison: string
  onSectionChange: SectionChangeHandler
}

export const StatusBreakdown: React.FC<Props> = ({
  stats,
  activeSection,
  changes,
  comparison,
  onSectionChange,
}) => (
  <>
    <BreakdownItem
      section="healthy"
      title="Healthy"
      stat={stats.healthy}
      activeSection={activeSection}
      changes={changes}
      comparison={comparison}
      onSectionChange={onSectionChange}
    />
    <BreakdownItem
      section="warning"
      title="Warning"
      stat={stats.warning}
      activeSection={activeSection}
      changes={changes}
      comparison={comparison}
      onSectionChange={onSectionChange}
    />
    <BreakdownItem
      section="broken"
      title="Broken"
      stat={stats.broken}
      activeSection={activeSection}
      changes={changes}
      comparison={comparison}
      onSectionChange={onSectionChange}
    />
  </>
)
